/*global define, console, window, HTMLImageElement, Promise*/
(window.MyModule = function ($, Behaviors) {
    "use strict";
    var module = {};
    function ScrollActivatedPoints(elem) {
        Behaviors.init(ScrollActivatedPoints, this, arguments);
        // var $thisElem = this.$elem;

        var $sidebar = $('.ScrollActivatedPoints-content_items');
        var offset = $sidebar.offset();
        var footerSize = $("footer[data-type='footer']");
        var animationElements = $('[id^="section-item-id-"]');

        var mobileSelectArrow = $('.ScrollActivatedPoints-items_mobile_select_arrow');

        var wpToolBar = $('#wpadminbar');
        var stickyHeader;
        var stickyHeaderInterval;

        var $window = $(window);

        if( $window.width() > 640 ) {
            setTimeout(function(){
                offset = $sidebar.offset();
            },500);
        } else {
            setTimeout(function(){
                offset = $sidebar.offset();
            },2000);
        }

        // mobileSelectArrow.on('click', function(){
        //     var $this = $(this);
        //     $this.parent().toggleClass('ScrollActivatedPoints-content_items--select_active');
        // });
        
        var dropdown = $('.ScrollActivatedPoints-content');
        dropdown.find('.ScrollActivatedPoints-content_items_dropdown-button').on('click', function (e) {
            e.stopPropagation();
            var $parent = $(this).parent();
        
            if ($parent.hasClass('ScrollActivatedPoints-content_items--select_active')) {
                $('.ScrollActivatedPoints-content_items').removeClass('ScrollActivatedPoints-content_items--select_active');
            } else {
                $('.ScrollActivatedPoints-content_items').removeClass('ScrollActivatedPoints-content_items--select_active');
                $parent.addClass('ScrollActivatedPoints-content_items--select_active');
            }
        });
        
        dropdown.find('.ScrollActivatedPoints-content_items_dropdown-menu').on('click', function (e) {
            e.stopPropagation();
        });
        
        dropdown.find('.ScrollActivatedPoints-content_items_dropdown-menu .ScrollActivatedPoints-item a').on('click', function (e) {
            var dropdownButtonText = $(this).text();
            $('.ScrollActivatedPoints-content_items').removeClass('ScrollActivatedPoints-content_items--select_active');
            dropdown.find('.ScrollActivatedPoints-content_items_dropdown-button span').text(dropdownButtonText);
        });
        
        $('html, body').on('click', function (e) {
            $('.ScrollActivatedPoints-content_items').removeClass('ScrollActivatedPoints-content_items--select_active');
        });


        stickyHeaderInterval = setInterval(function(){
            stickyHeader = $('.fl-theme-builder-header-sticky');
            if((stickyHeader.length) > 0) {
                clearInterval(stickyHeaderInterval);
            }
        },500);

        function sectionDetect(section) {
            var sidebarOffset = ($window.width() > 91200) ? $sidebar.outerHeight() / 2 : $sidebar.outerHeight();
            if(($window.scrollTop() + sidebarOffset) > section.offset().top) {
                var isDark = section.hasClass('dark-section');
                if(isDark) {
                    $sidebar.addClass('ScrollActivatedPoints-content_items--is_dark_section');
                } else {
                    $sidebar.removeClass('ScrollActivatedPoints-content_items--is_dark_section');
                }
                // var lastSection = $('[id^="section-item-id-"]:last-child');
                var lastSection = section.hasClass('hide-sidebar');
                if(lastSection) {
                    $sidebar.addClass('ScrollActivatedPoints-content_items--last_element_entered');
                } else {
                    $sidebar.removeClass('ScrollActivatedPoints-content_items--last_element_entered');
                }

            }
        }

        function sectionNav() {

            clearTimeout($.data(this, 'scrollTimer'));
            if ($sidebar.length > 0) {
                $.data(this, 'scrollTimer', setTimeout(function () {

                    var scrollTop = $window.scrollTop() + $('header.fl-builder-content').outerHeight();

                    $.each(animationElements, function (index) {

                        sectionDetect($(this));

                        var $this = $(this);
                        if (scrollTop >= $this.offset().top && scrollTop < $this.offset().top + $this.height()) {
                            if (!$('.ScrollActivatedPoints-item').eq(index).hasClass('ScrollActivatedPoints-item--active')) {
                                $('.ScrollActivatedPoints-item').removeClass('ScrollActivatedPoints-item--active');
                                $('.ScrollActivatedPoints-item').eq(index).addClass('ScrollActivatedPoints-item--active');
                            }
                        }

                        var $section = $(this);
                        setTimeout(function() {
                            if ( $window.scrollTop() > $section.offset().top ) {

                                    var heightPercentage = parseInt(($window.scrollTop() - $section.offset().top) / $section.outerHeight() * 115);
                                        
                                    if ( !$('.ScrollActivatedPoints-item').eq(index).hasClass('line-active')) {
                                        $('.ScrollActivatedPoints-item').eq(index).addClass('line-active');
                                    }
                                    if( $window.width() > 91200 ) {
                                        $('.ScrollActivatedPoints-item').eq(index).find('span').css('height', heightPercentage + '%');
                                    } else {
                                        $('.ScrollActivatedPoints-item').eq(index).find('span').css('width', heightPercentage + '%');
                                        // $('.ScrollActivatedPoints-item').eq(index).find('span').css('transform', 'translateX(' + (-101 + heightPercentage) + '% )');
                                    }

                                } else if ($window.scrollTop() < $section.offset().top) {

                                    $('.ScrollActivatedPoints-item').eq(index).removeClass('line-active');
                                    if( $window.width() > 91200 ) {
                                        $('.ScrollActivatedPoints-item').eq(index).find('span').css('height', '0%');
                                    } else {
                                        $('.ScrollActivatedPoints-item').eq(index).find('span').css('width', '0%');
                                        // $('.ScrollActivatedPoints-item').eq(index).find('span').css('transform', 'translateX(-101%)');
                                    }
                                }
                        },20);
                    });
                    var position = document.querySelector('.ScrollActivatedPoints-item.ScrollActivatedPoints-item--active') ? document.querySelector('.ScrollActivatedPoints-item.ScrollActivatedPoints-item--active').offsetTop - $sidebar.outerHeight() : 0;
                    $sidebar.animate({
                        'scrollTop': position
                    }, 300);
                }, 20));
            }
            var sidebarTopPosition = 0;

            if($(".ScrollActivatedPoints-content_items").length > 0) {
                if ($('#wpadminbar').length > 0) {
                    $sidebar.addClass("has-wp-admin-bar");
                }
                if(stickyHeader.length > 0) {
                    sidebarTopPosition += stickyHeader.outerHeight();
                }
                if(wpToolBar.length > 0) {
                    sidebarTopPosition += wpToolBar.outerHeight();
                }
                if ( $window.scrollTop() > offset.top - sidebarTopPosition ) {
                    clearInterval(stickyHeaderInterval);

                    $sidebar.addClass('ScrollActivatedPoints-content_items--activate-fixed-position');
                    
                    if( $window.width() > 91200 ) {
                        $sidebar.css('top', sidebarTopPosition + 15);
                    }  else {
                        $sidebar.css('top', sidebarTopPosition);
                    }
                    var footerTopPosition = ( $(document).height() - footerSize.outerHeight() + ($window.height() - stickyHeader.outerHeight() - $sidebar.outerHeight() - 40));
                    var windowScorllBottom = $window.scrollTop() + $window.height();
                    
                    if( windowScorllBottom > footerTopPosition ){
                        $sidebar.css('top', sidebarTopPosition + (footerTopPosition - windowScorllBottom) + 15);
                    }
                } else {
                    $sidebar.removeClass('ScrollActivatedPoints-content_items--activate-fixed-position');
                    $sidebar.css('top', 0);
                }
            }
        }

        $window.on('scroll', sectionNav);

        $('.ScrollActivatedPoints-item > a').on('click', function(event){
            event.preventDefault();
            var targetDiv = $(this.dataset.href);
            
            var offsetToolBar = 0;
            if((wpToolBar).length > 0) {
                var offsetToolBar = wpToolBar.outerHeight();
            }
            
                if((targetDiv).length > 0) {
                    if( $window.width() > 550 ) {
                        $('html, body').animate({
                            scrollTop: targetDiv.offset().top - offsetToolBar - 100
                        }, 850);
                    } else {
                        $('html, body').animate({
                            scrollTop: targetDiv.offset().top - offsetToolBar - 5
                        }, 850);
                    }

                }
            
        });

        


    }
    Behaviors.inherit(ScrollActivatedPoints, Behaviors.Behavior);
    ScrollActivatedPoints.QUERY = "[data-ScrollActivatedPoints]";
    ScrollActivatedPoints.ELEMENTS = {
        loadMoreButton: ".AwardTabs-content_tabs_items_item_loadMore__button",
    };
    Behaviors.register_behavior(ScrollActivatedPoints);
    module.ScrollActivatedPoints = ScrollActivatedPoints;
    return module;
}(window.jQuery, window.Behaviors));



(function($){

    $(document).ready(function(){
        //This script is added because too many elements on the Careers page are affecting anchor links to anchor on the exact section
        //Css is added to the global.less as well ( body:not(.anchor-load-time-load) )
        if(window.location.pathname == '/careers/') {
            if(window.location.hash == '#career-opportunities') {

                $(window).on("load", function() {
                    $('body').addClass('anchor-load-time-load');
                    $('html, body').animate({
                        scrollTop: $('#career-opportunities').offset().top - 82
                    }, 0);
                });
            }
        }
    });
})(jQuery);